import { useEffect, useRef } from "react";

const release = (eng) => () => eng.current?.hold(false);
import { createLiving, EFFECTS } from "../../lib/living";

export { EFFECTS };

export function LivingPainting({ painting, effects, strength = 1, className = "", testid = "living-painting", small = false, style }) {
  const ref = useRef(null);
  const fx = (effects || painting.effects || []).filter((e) => EFFECTS.includes(e));
  const key = fx.join(",");
  const eng = useRef(null);
  useEffect(() => {
    eng.current = createLiving(ref.current, painting, { effects: fx, strength, small });
    return eng.current.stop;
  }, [painting.id, painting.image_url, key, strength, small]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <canvas
      ref={ref}
      data-testid={testid}
      data-effects={key}
      role="img"
      aria-label={painting.title}
      className={className}
      style={{ aspectRatio: painting.aspect_ratio || 1, ...style }}
      onPointerDown={() => eng.current?.hold(true)}
      onPointerUp={release(eng)}
      onPointerLeave={release(eng)}
      onPointerCancel={release(eng)}
    />
  );
}
